import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import BackupWallet from '../components/BackupWallet/BackupWallet'
import AuthFooter from '../components/shared/AuthFooter/AuthFooter'

import { copyTextFromDisplay } from '../components/shared/QbDisplay/QbDisplay'
import { WALLET_BACKUP_ACTIONS } from '../store/actions/wallet'
import requireWallet from '../hoc/requireWallet'
import requireUnlocked from '../hoc/requireUnlocked'
import { extractWalletFromHistory } from '../util/wallet'
import { RECEIVE_WALLET_NAV } from '../constants/navigation'

class BackupWalletContainer extends Component {

  state = {
    mnemonic: ''
  }

  componentDidMount() {
    this.setState({
      mnemonic: extractMnemonic(this.props.history)
    })
  }

  componentWillUnmount() {
    this.props.resetWalletBackupState()
  }

  copyMnemonic = () => {
    copyTextFromDisplay(this.state.mnemonic)
    this.props.onCopyToClipboard()
  }

  printMnemonic = () => {
    window.print()
  }

  navigateToReceive = () => {
    this.props.history.push(RECEIVE_WALLET_NAV)
  }

  render() {
    const { t, copySuccessMsg, location } = this.props
    const { mnemonic } = this.state
    return (
      <div className="main-container main-container--flex-column">
        <BackupWallet
          t={t}
          mnemonic={mnemonic}
          copySuccessMsg={copySuccessMsg}
          copyMnemonic={this.copyMnemonic}
          printMnemonic={this.printMnemonic}
          walletCreated={location && location.state ? location.state.walletCreated : false}
          navigateToReceive={this.navigateToReceive}
        />
        <AuthFooter />
      </div>
    )
  }
}

const mapStateToProps = ({ walletReducer }) => {
  const { backupProfile } = walletReducer
  return {
    copySuccessMsg: backupProfile.copySuccessMsg
  }
}

const mapDispatchToProps = dispatch => 
  bindActionCreators({
    ...WALLET_BACKUP_ACTIONS
  }, dispatch)

export default requireWallet(requireUnlocked(connect(mapStateToProps, mapDispatchToProps)(BackupWalletContainer)))

function extractMnemonic(history) {
  const wallet = extractWalletFromHistory(history)
  return wallet.mnemonic || ''
}


// WEBPACK FOOTER //
// ./src/containers/BackupWalletContainer.js